<app-leaderboard [rows]="rows"></app-leaderboard>
<app-latest-bets [rows]="rows"></app-latest-bets>


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/leaderboard-bets-wrapper/leaderboard-bets-wrapper.template.html